import * as THREE from 'three'
import {
    OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js'
import './style.css'

/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

/**
 * Particles
 */

// geometry
// const particlesGeometry = new THREE.SphereBufferGeometry(1, 32, 32);

const buffer = new THREE.BufferGeometry();

const count = 1;
const positions = new Float32Array(count * 3);

for (let i = 0; i < count * 3; i++ ) {
    positions[i] = (Math.random() - 0.5) * 10;
}

buffer.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

// material
const particlesMaterial = new THREE.PointsMaterial({
    size: 2,
    sizeAttenuation: false
});

// point
const particles = new THREE.Points(buffer, particlesMaterial)

scene.add(particles);
/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)

controls.autoRotate = true;
controls.autoRotateSpeed = 5;
controls.enabled =  false;


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    preserveDrawingBuffer: true,
   
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// renderer.autoClearColor = false;


setTimeout(() => {
    renderer.autoClear = !renderer.autoClear;
}, 1000);


/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    scene.rotation.x += 0.01

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()